var _componentUniform = function($context) {
    if (!$().uniform) {
        console.warn('Warning - uniform.min.js is not loaded.');
        return;
    }

    ($context instanceof jQuery ? $context.find('.js-form-control-uniform') : $('.js-form-control-uniform')).uniform();
};

function init($context) {
    _componentUniform($context);
}


export const InputsBasic = {
    init
}
